<template>
  <div :class="`WindowHeader_${styleNames}`">
    <div class="index_Logo" @click.stop="goRoute('/')">
      <div class="logo_box">
        <img src="@/assets/logo_red.png" style="width: 100%; height: 100%" />
      </div>
    </div>
    <div class="margin">
      <template v-if="isMobile">
        <div style="height: 100%" v-for="(item, index) in navMenuPath" :key="index">
          <div
            @click.stop="goRoute(item.path)"
            @mouseenter="handleMouseEnter(index)"
            @mouseleave="handleMouseLeave"
            style="position: relative"
            :class="[
              item.path === currentPath ? 'currentPath' : '',
              'margin_nav_menu',
            ]"
            :key="index"
          >
            {{ item.title }}
            <div
              v-if="index == activeIndex && item.sonPath"
              class="margin_sonPath"
            >
              <template v-for="(dict, indexs) in item.sonPath">
                <div
                  @click.stop="goRoute(dict.path)"
                  :key="indexs"
                  :class="[
                    currentPath === dict.path ? 'levelPath' : '',
                    'margin_sonPath_dict',
                    ,
                  ]"
                >
                  {{ dict.suntitle }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>

      <div v-else class="min_drawer">
        <span
          @click.stop="drawer = !drawer"
          class="el-icon-s-fold"
          style="color: #cc0a42"
        ></span>
      </div>
      <el-drawer
        title=""
        :modal="false"
        :visible.sync="drawer"
        :with-header="false"
        size="60%"
      >
        <div style="padding: 2rem 1rem">
          <div
            v-for="(item, index) in navMenuPath"
            :key="index"
            class="margin_nav_menu"
            @click.stop="goRoute(item.path)"
          >
            <div style="height: 44px; align-content: center">
              {{ item.title }}
            </div>
            <div
              class="margin_nav_menu min_margin_nav_menu"
              v-for="(dict, indexs) in item.sonPath"
              :key="indexs"
              @click.stop="goRoute(dict.path)"
            >
              {{ dict.suntitle }}
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      drawer: false,
      navMenuPath: [
        { title: "首页", path: "/" },
        {
          title: "产品和解决方案",
          path: "/productSSP",
          sonPath: [
            { suntitle: "无极·SSP", path: "/productSSP" },
            // { suntitle: "和合·ADX", path: "/productADX" },
            { suntitle: "精准营销", path: "/productPrecise" },
            { suntitle: "异业推广", path: "/productPromotion" },
          ],
        },
        { title: "操作手册", path: "/docs" },
        { title: "联系我们", path: "/AboutUs" },
      ],
      currentPath: this.$route.path,
      activeIndex: null,
      isMobile: false,
    };
  },
  computed: {
    styleNames() {
      return this.$store.state.IndexStore.styleName;
    },
  },
  created() {
    // 初始化时设置 activeIndex
    this.setActiveIndexBasedOnPath();
    this.checkIfMobile();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    // 确保刷新后 activeIndex 正确
    this.setActiveIndexBasedOnPath();
    console.log(this.currentPath, "mounted");
    console.log(this.$route.path, "mounted--$route.path");
  },
  watch: {
    $route(to, from) {
      this.currentPath = to.path;
    },
  },
  methods: {
    // 判断是否为移动端
    checkIfMobile() {
      this.isMobile = window.innerWidth >= 768; // 768px 视为移动端
    },
    // 根据当前路径设置 activeIndex
    setActiveIndexBasedOnPath() {
      const currentPath = this.$route.path;
      const foundItem = this.navMenuPath.find((item, index) => {
        if (item.path === currentPath) {
          this.activeIndex = index; // 设置当前激活的索引
          return true;
        }
        if (item.sonPath) {
          const foundSon = item.sonPath.find((son) => son.path === currentPath);
          if (foundSon) {
            this.activeIndex = index; // 设置当前激活的索引
            return true;
          }
        }
        return false;
      });

      if (!foundItem) {
        this.activeIndex = null; // 如果没有找到对应路径，清空 activeIndex
      }
    },

    handleMouseEnter(index) {
      this.activeIndex = index;
    },
    handleMouseLeave() {
      this.activeIndex = null;
    },
    goRoute(path) {
      if (!this.isMobile) {
        this.drawer = !this.drawer;
      }
      if (path == "/AboutUs") {
        // 获取页面的高度
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth", // 平滑滚动
        });
        return;
      }
      if (this.$route.path !== path) {
        this.currentPath = path;
        this.$router.push(path);
        this.setActiveIndexBasedOnPath(); // 路由跳转后更新 activeIndex
      }
    },
    handleScroll() {
      const scrollY = window.scrollY; // 获取滚动数值
      if (scrollY > 50) {
        if (this.$store.state.IndexStore.styleName != "black") {
          this.$store.dispatch("IndexStore/setStyleName", "black");
        }
      } else {
        if (this.$store.state.IndexStore.styleName != "convention") {
          this.$store.dispatch("IndexStore/setStyleName", "convention");
        }
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    // 在路由更新时重新设置 activeIndex
    this.setActiveIndexBasedOnPath();
    next();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.index_Logo {
  width: 20%;
  min-width: 158px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.margin {
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: right;
  align-items: center;
  // margin-right: 10%;
  .min_drawer {
    font-size: 2rem;
    margin-right: 2rem;
  }
}

/* pc端样式 */
@media (min-width: 768px) {
  .margin_nav_menu {
    height: 100%;
    margin: 0 30px;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    font-size: 1rem;
    white-space: nowrap;
    position: relative;
  }
  .margin_sonPath {
    width: 158px;
    height: auto;
    padding: 5px;
    position: absolute;
    top: 60px;
    text-align: center;
    background-color: rgba(255, 255, 255);
    color: #313131;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 400;
    .margin_sonPath_dict {
      width: 100%;
      height: 36px;
      text-align: center;
      align-content: center;
    }
    .margin_sonPath_dict:hover {
      color: #cc0a42;
    }
  }
}

/* 移动端样式 */
@media (max-width: 768px) {
  .margin_nav_menu {
    min-height: 44px;
    height: auto;
    width: 100%;
    color: #000;
    text-align: left;
    align-content: center;
    font-size: 1rem;
    white-space: nowrap;
  }
  .min_margin_nav_menu {
    font-size: 0.9rem;
    text-align: left;
    align-content: center;
    margin: 0 0 0 1rem;
  }
}

.margin_nav_menu.currentPath {
  font-weight: bold; /* 加粗字体 */
  color: #cc0a42;
  // font-size: 1.2rem;
}
.levelPath {
  // font-weight: bold; /* 加粗字体 */
  color: #cc0a42;
}
</style>
